<script>
export default {
    props: {
        categories: {type: Array, required: true},
        categoryTree: {type: Object}
    },

    emits: ['pill-cliced'],

    methods: {
        findNodeById(id, node=null) {
            if (node == null)
                node = this.categoryTree

            if (parseInt(node.id) === parseInt(id)) {
                return node;
            }

            for (const child of node.children) {
                const foundNode = this.findNodeById(id, child);
                if (foundNode)
                    return foundNode;
            }
        },
    },
}
</script>

<template>
  <span v-if="categoryTree != null">
    <a href="" v-for="c in categories" :key="c.id"
     class="badge badge-pill bg-primary me-1"
     style="text-decoration:none"
     @click.prevent="$emit('pill-clicked', findNodeById(c.id))">
        {{ c.name }}
    </a>
  </span>
  <span v-else>
    <div v-for="c in categories" :key="c.id" class="badge badge-pill bg-primary me-1">
        {{ c.name}}
    </div>
  </span>
</template>